import dayjs from 'dayjs';

export const PRODUCT_FIELDS = [
  { key: 'name', label: 'Product Name' },
  { key: 'ProductFamily', label: 'Product family' },
  {
    key: 'UnitPrice',
    label: 'Sales price',
    render: (val: any) => (val ? `$${val}` : 'N/A'),
  },
  { key: 'Quantity', label: 'Quantity' },
  {
    key: 'ServiceDate',
    label: 'Date',
    render: (val: any) => (val ? dayjs(val).format('MM/DD/YYYY') : 'N/A'),
  },
  { key: 'ListPrice', label: 'List price', render: (val: any) => (val ? `$${val}` : 'N/A') },
];
